export const isXPairedDeviceHeaderSupported = (url: string): boolean =>
  [
    '/cars',
    '/user/transactions',
    '/user/rentals',
    '/rental',
    '/user/sendVerificationCode',
  ].includes(url);
